import { useContext } from 'react';

import { ConfigContext } from '../context/config';

/**
 * Get global settings.
 *
 * @returns {Config}
 */
export function useConfig() {
  const value = useContext(ConfigContext);
  return value;
}

/**
 * @typedef {object} Config
 * @prop {object} config
 * @prop {boolean} config.isHeavy
 * @prop {boolean} config.enableMobileMap
 * @prop {boolean} config.disableChosenTyre
 * @prop {boolean} config.googleMapsAllowed
 * @prop {boolean} config.googleMapsReady
 * @prop {string} config.mapTitle
 * @prop {string[]} config.addressFields
 * @prop {string[]} config.nameFields
 * @prop {boolean} config.reorderCompanyName
 * @prop {boolean} config.skipLandingPage
 * @prop {string} config.countryCode
 * @prop {string} config.distanceUnit
 * @prop {number} config.resourceTimestamp
 * @prop {string} config.studioUrl
 * @prop {boolean} config.includeServices
 * @prop {boolean} config.showServices
 * @prop {string} config.mapType
 * @prop {object} config.initialLocation
 * @prop {string} config.initialAddress
 * @prop {string[]} config.restrictAutocompleteToCountries
 * @prop {boolean} config.includeCities
 * @prop {Filter[]} config.filters
 * @prop {object} itemPropMap
 * @prop {(object) => void} setConfig
 */

/**
 * @typedef {object} Filter
 * @prop {string} apiValue
 * @prop {string} value
 * @prop {string} name
 * @prop {number} companyType
 * @prop {number} productCategory
 * @prop {boolean} active
 * @prop {boolean} showUI
 */
